<!--
 * @Author: wanghui@ykccn.com
 * @Date: 2023-02-14
 * @Description: 营销管理/平台营销工具/平台卡券活动/详情
-->
<template>
  <scroll-layout>
    <template slot="header">
      <div v-if="pageButtons.length > 0" class="button-wrap">
        <ykc-button
          v-for="(button, index) in pageButtons"
          :key="button.id || index"
          v-bind="button"
          @click="button.handleClick(button, $event)">
          {{ button.text }}
        </ykc-button>
      </div>
    </template>
    <div>
      <ykc-detail :titles="['活动信息']" :className="'all'">
        <div slot="cvBody">
          <div class="form-detail">
            <ykc-form :label-position="'left'" label-width="90px">
              <ykc-detail-item label="活动名称：">
                <span>{{ dealData(detail.activityName) }}</span>
              </ykc-detail-item>
              <ykc-detail-item label="对外名称：">
                <span>{{ dealData(detail.outName) }}</span>
              </ykc-detail-item>
              <ykc-detail-item label="活动简介：">
                <span class="text-wrap">{{ dealData(detail.activityDesc) }}</span>
              </ykc-detail-item>
              <ykc-detail-item label="活动类型：">
                <span>会员权益</span>
              </ykc-detail-item>
              <ykc-detail-item label="活动状态：">
                <span>
                  {{ statusLabel(detail.activityStatus) }}
                </span>
              </ykc-detail-item>
              <ykc-detail-item label="活动时间：">
                <span>
                  {{ dealData(detail.activityBeginTime) }} ~{{ dealData(detail.activityEndTime) }}
                </span>
              </ykc-detail-item>
              <ykc-detail-item label="修改时间：">
                <span>{{ dealData(detail.modifiedTime) }}</span>
              </ykc-detail-item>
              <ykc-detail-item label="修改人：">
                <span>{{ dealData(detail.createdAccount) }}</span>
              </ykc-detail-item>
              <ykc-detail-item label="创建时间：">
                <span>{{ dealData(detail.createdTime) }}</span>
              </ykc-detail-item>
              <ykc-detail-item label="创建人：">
                <span>{{ dealData(detail.createdAccount) }}</span>
              </ykc-detail-item>
              <ykc-detail-item label="可用城市：">
                <span v-if="detail.cityScope === '3'">全国</span>
                <template v-if="detail.cityScope !== '3'">
                  <span class="text-wrap">{{ dealCity(detail.cityList) }}</span>
                </template>
              </ykc-detail-item>
              <ykc-detail-item label="小程序链接：">
                {{
                  dealData(`/pagesMyCenter/memberCard/benefitsBuy?activityId=${detail.activityId}`)
                }}
                <span
                  class="copy"
                  @click="
                    copyActivity(
                      `/pagesMyCenter/memberCard/benefitsBuy?activityId=${detail.activityId}`
                    )
                  "></span>
              </ykc-detail-item>
              <ykc-detail-item label="活动说明：">
                <span class="activity-remark">{{ dealData(detail.activityRemark) }}</span>
              </ykc-detail-item>
            </ykc-form>
          </div>
        </div>
      </ykc-detail>
      <ykc-detail :titles="['活动配置']" :className="'all'">
        <div slot="cvBody">
          <div class="form-detail">
            <ykc-form :label-position="'left'" label-width="100px">
              <ykc-detail-item label="卡券设置：">
                <ykc-table
                  :data="dealRewordData(detail.rewardList)"
                  :columns="tableColumns"></ykc-table>
              </ykc-detail-item>
            </ykc-form>
          </div>
        </div>
      </ykc-detail>
    </div>
  </scroll-layout>
</template>

<script>
  import { couponActivity } from '@/service/apis';
  import { offlineExport } from '@/utils';

  export default {
    props: {
      activityId: {
        type: String,
      },
    },
    data() {
      return {
        pageButtons: [
          {
            id: '1',
            text: '返回',
            type: 'plain',
            handleClick: () => {
              this.$router.go(-1);
            },
          },
        ],
        defaultImageUrl: '',
        detail: {}, // 详情数据
        // 表格列
        tableColumns: [
          {
            label: '售卖金额',
            prop: 'rewardThreshold',
            width: 240,
          },
          {
            label: '会员权益卡',
            prop: 'cardCouponName',
            width: 240,
            scopedSlots: {
              default: ({ row }) => {
                return (
                  <el-link type="primary" onClick={() => this.handleCellClick(row)}>
                    {row.cardCouponName}
                  </el-link>
                );
              },
            },
          },
          { label: '卡面额', prop: 'faceValue', width: 240 },
          { label: '服务费折扣', prop: 'servicePercentage', width: 240 },
        ],
        activeName: 'first',
        rewardList: [], // 卡券列表数据
      };
    },
    computed: {},
    created() {
      this.getDetail();
    },
    methods: {
      handleCellClick(row) {
        const routeUrl = this.$router.resolve({
          path: '/marketingCenter/platformMarketingTools/benefitCard',
          query: {
            data: row.rewardId,
          },
        });
        window.open(routeUrl.href, '_blank');
      },

      doExport() {
        offlineExport({
          downloadType: 'marketing_export',
          jsonNode: {
            downloadKey: 'scanActivityUserList',
            activityId: this.activityId,
          },
        });
      },
      dicStatus() {
        // 活动状态（1:进行中，2:未开始，3:已结束(手动停用)，4:已结束(活动到期)，5:已结束(卡券不足)，6:已结束(卡券失效)）
        return [
          { id: '1', name: '进行中' },
          { id: '2', name: '未开始' },
          { id: '3', name: '已结束(手动停用)' },
          { id: '4', name: '已结束(活动到期)' },
          { id: '5', name: '已结束(卡券不足)' },
          { id: '6', name: '已结束(卡券失效)' },
        ];
      },
      /**
       * 卡券活动字典对应的文案
       * @param status
       * @returns {string|*|string}
       */
      statusLabel(status) {
        if (!status) {
          return '——';
        }
        const obj = this.dicStatus()?.find(item => item.id === status);
        return obj?.name || '——';
      },
      getDetail() {
        const requestDetail = couponActivity.benefitActivityDetail({
          activityId: this.activityId,
        });
        requestDetail.then(res => {
          this.detail = res || {};
        });
      },
      /**
       * 获取详情数据
       */
      dealData(data) {
        return data || '—';
      },
      /**
       * 获取详情数据
       */
      dealRewordData(data) {
        return data.map(item => ({
          ...item,
          servicePercentage: `${item.servicePercentage}%`,
        }));
      },
      /**
       * 处理城市数据
       */
      dealCity(data) {
        return data.map(item => item.provinceName + item.cityName).join(',');
      },
      copyActivity(str) {
        this.$copyText(str)
          .then((e, err) => {
            if (e) {
              this.$message.success('复制成功');
            }
            if (err) {
              this.$message.error('复制失败');
            }
          })
          .catch(error => {
            console.log('error', error);
          });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .all {
    margin-bottom: 16px;
  }
  .ykc-tree.detailTree {
    padding-top: 0;
  }
  .activity-photo {
    width: 80px;
    height: 80px;
    background: #f5f8ff;
    border-radius: 10px;
    img {
      width: 80px;
      height: 80px;
      border-radius: 10px;
    }
  }
  .activity-remark {
    white-space: pre-wrap;
    word-break: break-word;
  }
  .copy {
    margin-left: 6px;
    width: 14px;
    cursor: pointer;
    background: url('~@/assets/images/staging/copy.png') no-repeat 100%;
  }
</style>
